import { Component, OnInit } from '@angular/core';
import { AdalService } from '../adal/adal.service';

@Component({
    selector: 'home',
    template: require('./home.component.html'),
})
export class HomeComponent implements OnInit {
    public message: string;
    public values: any[];
    public userInfo: any;

    constructor(private adalService: AdalService) {
        this.userInfo = this.adalService.userInfo;
    }

    ngOnInit() {
        if (this.userInfo.isAuthenticated) {
            this.adalService.logOut();
            this.adalService.clearCache();
        }
    }
}


/** WEBPACK FOOTER **
 ** ./app/home/home.component.ts
 **/